import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import logoPage from "../static/media/logo.webp";

const blue = "#0A3D91";

const PrivacyPolicies = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        py: { xs: 3, md: 6 },
        px: 2,
        maxWidth: "80%",
        mx: "auto",
      }}
    >
      <Helmet>
        <title>Políticas de Privacidad | D&R Soluciones Informáticas</title>
        <meta
          name="description"
          content="Conozca las Políticas de D&R Soluciones Informáticas. Descubra cómo recopilamos, usamos y protegemos su información personal en nuestro sitio web."
        />
      </Helmet>

      <Box sx={{ textAlign: "center", mb: 4 }}>
        <img
          src={logoPage}
          alt="D&R Soluciones Informáticas"
          style={{ maxWidth: "120px", height: "auto" }}
        />
      </Box>

      <Typography
        component="h1"
        sx={{
          textAlign: "center",
          fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.3rem" },
          fontWeight: "bold",
          mb: 4,
          color: blue,
        }}
      >
        Políticas de Privacidad
      </Typography>

      <Box sx={{ lineHeight: 1.7, color: "#444" }}>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            mb: 3,
          }}
        >
          En D&R Soluciones Informáticas, valoramos y respetamos su privacidad. Estas políticas están diseñadas
          para informarle sobre cómo recopilamos, utilizamos y protegemos la información personal
          proporcionada a través de nuestro sitio web.
        </Typography>

        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.4rem" },
            fontWeight: "bold",
            mb: 2,
            color: "#333",
          }}
        >
          Recopilación de Información
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            mb: 3,
          }}
        >
          Los datos personales que recopilamos son proporcionados directamente por usted al completar
          formularios en nuestro sitio web. Esto incluye información básica como nombre, número de teléfono
          y dirección de correo electrónico. Dichos datos se recopilan únicamente para poder contactarlo
          y brindarle asesoría personalizada relacionada con nuestros servicios.
        </Typography>

        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.4rem" },
            fontWeight: "bold",
            mb: 2,
            color: "#333",
          }}
        >
          Uso de la Información
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            mb: 2,
          }}
        >
          La información proporcionada se utiliza exclusivamente para:
        </Typography>
        <Box
          component="ul"
          sx={{
            pl: 3,
            mb: 2,
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            lineHeight: 1.8,
          }}
        >
          <li>Contactarlo y responder a sus consultas.</li>
          <li>Ofrecerle una asesoría personalizada sobre nuestros servicios.</li>
          <li>Proporcionarle información sobre nuestras ofertas y promociones.</li>
        </Box>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            mb: 3,
          }}
        >
          No utilizamos esta información para otros fines, y bajo ninguna circunstancia será vendida
          o compartida con terceros.
        </Typography>

        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.4rem" },
            fontWeight: "bold",
            mb: 2,
            color: "#333",
          }}
        >
          Almacenamiento de Datos
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            mb: 3,
          }}
        >
          No almacenamos los datos personales proporcionados en bases de datos. Toda la información recopilada
          a través de nuestro sitio se utiliza de forma puntual y se elimina después de cumplido el propósito de contacto.
        </Typography>

        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.4rem" },
            fontWeight: "bold",
            mb: 2,
            color: "#333",
          }}
        >
          Uso de Cookies
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            mb: 3,
          }}
        >
          Este sitio web no utiliza cookies ni herramientas de seguimiento de usuarios. Nuestro sitio
          es exclusivamente informativo y publicitario.
        </Typography>

        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.4rem" },
            fontWeight: "bold",
            mb: 2,
            color: "#333",
          }}
        >
          Seguridad de la Información
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            mb: 3,
          }}
        >
          Hemos implementado medidas técnicas y organizativas para proteger su información personal
          contra el acceso no autorizado, pérdida o uso indebido.
        </Typography>

        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.4rem" },
            fontWeight: "bold",
            mb: 2,
            color: "#333",
          }}
        >
          Derechos de los Usuarios
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            mb: 2,
          }}
        >
          Usted tiene derecho a:
        </Typography>
        <Box
          component="ul"
          sx={{
            pl: 3,
            mb: 3,
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            lineHeight: 1.8,
          }}
        >
          <li>Solicitar la eliminación de su información personal.</li>
          <li>Consultar el uso específico de sus datos proporcionados.</li>
          <li>Contactarnos si tiene alguna duda o inquietud relacionada con sus datos personales.</li>
        </Box>

        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.4rem" },
            fontWeight: "bold",
            mb: 2,
            color: "#333",
          }}
        >
          Contacto
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
            mb: 3,
          }}
        >
          Si tiene alguna pregunta o necesita más información sobre nuestras políticas de privacidad,
          puede comunicarse con nosotros a través de nuestro formulario de contacto o mediante el
          correo electrónico <strong>soporte@drsolucionesinformaticas.com</strong>.
        </Typography>

        <Typography
          component="h2"
          sx={{
            fontSize: { xs: "1.1rem", sm: "1.2rem", md: "1.4rem" },
            fontWeight: "bold",
            mb: 2,
            color: "#333",
          }}
        >
          Actualizaciones
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.025rem", md: "1.15rem" },
          }}
        >
          Estas políticas pueden ser actualizadas periódicamente. Le recomendamos revisar esta página
          para mantenerse informado sobre cómo protegemos su información personal.
        </Typography>
      </Box>
    </Box>
  );
};

export default PrivacyPolicies;
